import { z } from 'zod';

const PlanFeatureSchema = z.object({
  title: z.string(),
  id: z.string(),
});

const BaseContentSchema = z.object({
  slug: z.string(),
  title: z.string(),
  heading: z.string(),
  features: z.array(z.string()).nonempty(),
  documents: z.array(
    z.object({
      type: z.string(),
      url: z.string().url(),
    })
  ),
  plan_features: z.array(PlanFeatureSchema).nonempty(),
});

const BasePlanCardsDataSchema = z.object({
  id: z.number(),
  product: z.string(), //convert to enum
  prices: z
    .array(
      z.object({
        id: z.number(),
        name: z.string(),
        amount: z.number(),
        discounts: z.array(
          z.object({
            description: z.string(),
            amount: z.number(),
            frequency: z.string(),
            repeats: z.number(),
          })
        ),
      })
    )
    .nonempty(),
});

export { BaseContentSchema, BasePlanCardsDataSchema };
